export const segmentConstants = {
  AND: 1,
  DEFAULT_CUSTOM_FILTER: "DEFAULT_CUSTOM_FILTER",
};
